import { AppContext } from "App";
import { ODOO_COMPANY_IDS } from "AppSettings";
import Button from "components/base/Button";
import { useModals } from "ModalProvider";
import { OdooContext } from "OdooProvider";
import { useContext } from "react";
import { OS_SYNC_TO_ODOO } from "utils/permissions";
import { PlanContext } from "../PlanForm";
import SyncPlanToOdooView from "../syncPlanToOdooViews";

const OdooView = ({ didSyncedToOdoo }) => {
  const { originalPlan } = useContext(PlanContext);
  const { hasPermission } = useContext(AppContext);
  const { odooUrl } = useContext(OdooContext);
  const syncToOdooModal = useModals();

  function trySyncToOdoo() {
    syncToOdooModal.present({
      title: "Sync Plan to Odoo",
      maxWidth: "max-w-6xl",
      children: (
        <SyncPlanToOdooView
          planId={
            originalPlan.parent ? originalPlan.parent.id : originalPlan.id
          }
          odooObject={originalPlan.odooObject}
          didSyncedToOdoo={didSyncedToOdoo}
        />
      ),
    });
  }

  return (
    <div className="card">
      <h5 className="text-purple-600">AB Odoo</h5>

      {originalPlan.playType === "AB_INTERNAL_TRANSFER" && (
        <div className="mt-2 font-semibold text-orange-600">
          Note this plan is an internal transfer, when this plan is confirmed
          and auto created in odoo, the `Schdeudle Date` will NOT be set as the
          `plan ready date`, you might need to set it manually after you `MARK
          AS TO DO` in Odoo.
        </div>
      )}

      <div className="opacity-70 text-xs mt-1">
        WIS auto create or update Sales Order or Internal Transfer to Odoo once
        Sales Confirmed.
      </div>

      {originalPlan.odooObject ? (
        <div className="mt-4">
          <a
            className="text-purple-600"
            target="_blank"
            href={
              originalPlan.odooObject.objectType === "TRANSFER"
                ? `${odooUrl}/web#id=${originalPlan.odooObject.objectId}&action=350&active_id=17&model=stock.picking&view_type=form&menu_id=222&cids=1`
                : `${odooUrl}/web#id=${originalPlan.odooObject.objectId}&menu_id=408&cids=${
                    ODOO_COMPANY_IDS[originalPlan.wisCustomer.system] || 1
                  }&action=312&model=sale.order&view_type=form`
            }
            rel="noreferer"
          >
            {originalPlan.odooObject.objectName}
          </a>

          {hasPermission(OS_SYNC_TO_ODOO) ? (
            <Button className="mt-2" onClick={trySyncToOdoo}>
              Sync to Odoo
            </Button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default OdooView;
